module.exports = __webpack_public_path__ + "img/01.a4d6aad2.png";